import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ff232b8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container center"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wallet__title" }, "Список хранится 180 дней", -1))
const _hoisted_4 = { class: "wallet__table none-display-md" }
const _hoisted_5 = { class: "display-md" }
const _hoisted_6 = { class: "wallet__mobile-table-row mobile-table__row gap--10" }
const _hoisted_7 = {
  key: 0,
  class: "items-in-line gap--5"
}
const _hoisted_8 = { class: "medium" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Добавьте объявления в сравнение", -1))

import { computed, onMounted, ref, Ref } from 'vue';
import { HeaderType, ItemType } from '@/types/TableTypes';
import { useCompareStore } from '@/store/modules/compare';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'CompareList',
  setup(__props) {

const headers = computed((): HeaderType[] => {
  return [
    {
      text: 'Создан',
      value: 'createDate',
      align: 'center',
    },
    {
      text: 'Список',
      value: 'list',
      align: 'left',
      alignValue: 'left',
    },
    {
      text: '',
      value: 'eye',
      align: 'center',
      click: showCompare,
    },
    {
      text: '',
      value: 'delete',
      align: 'center',
      alignValue: 'center',
      click: deleteCompare,
    },
  ];
});
const values: Ref<ItemType[]> = ref([]);
const prepareValues: Ref<ItemType[]> = ref([]);
const isLoading: Ref<boolean> = ref(false);
const successDeleteMessage: Ref<string | undefined> = ref(undefined);
const router = useRouter();
const showCompare = async (item: ItemType) => {
  await router.push({ name: 'compare', query: { id: String(item['id'].value) } });
  useCompareStore().changeCurrentCompare(
    {
      id: +item['id'].value,
      name: String(item['list'].value),
    },
    [],
  );
};
const deleteCompare = async (item: ItemType) => {
  values.value = values.value.map(el => {
    if (el['id'].value === item['id'].value) {
      return { ...el, delete: { ...el.delete, isLoading: true } };
    }

    return el;
  });
  try {
    const res = await useCompareStore().deleteCompare(+item['id'].value);

    if (res) {
      successDeleteMessage.value = res.success;
      values.value = values.value.filter(el => {
        return el['id'].value !== item['id'].value;
      });
    }
  } catch {
    values.value = values.value.map(el => {
      if (el['id'].value === item['id'].value) {
        return { ...el, delete: { ...el.delete, isLoading: false } };
      }

      return el;
    });
  }
};

onMounted(async () => {
  isLoading.value = true;

  try {
    const comparisons = await useCompareStore().getComparisons();

    if (comparisons) {
      comparisons.forEach(el => {
        values.value.push({
          id: { value: el.id },
          createDate: { value: new Date(el.created_at)?.toLocaleString() },
          list: { value: el.name },
          eye: { value: '', icon: 'visibility' },
          delete: { value: '', icon: 'delete', isLoading: false },
        });
      });
      prepareValues.value = values.value;
    }
  } finally {
    isLoading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_base_spinner = _resolveComponent("base-spinner")!
  const _component_base_table = _resolveComponent("base-table")!
  const _component_base_icon = _resolveComponent("base-icon")!
  const _component_base_pagination_group = _resolveComponent("base-pagination-group")!
  const _component_base_card = _resolveComponent("base-card")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_info_modal = _resolveComponent("base-info-modal")!

  return (isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_base_spinner, {
          size: 50,
          color: "#009D3E"
        })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        (prepareValues.value.length)
          ? (_openBlock(), _createBlock(_component_base_card, {
              key: 0,
              class: "wallet",
              fullWidthMobile: ""
            }, {
              default: _withCtx(() => [
                _hoisted_3,
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_base_table, {
                    emits: ['showCompare'],
                    headers: headers.value,
                    items: prepareValues.value,
                    style: 'simple',
                    onShowCompare: showCompare
                  }, null, 8, ["headers", "items"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prepareValues.value, (value) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(headers.value, (header) => {
                        return (_openBlock(), _createElementBlock("div", {
                          style: _normalizeStyle({ gridArea: header.value })
                        }, [
                          (!value[header.value].icon)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                _createElementVNode("span", _hoisted_8, _toDisplayString(header.text) + ":", 1),
                                _createTextVNode(" " + _toDisplayString(value[header.value].value), 1)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createVNode(_component_base_icon, {
                                  name: value[header.value]?.icon,
                                  clickable: "",
                                  color: "#94857d",
                                  height: "18",
                                  width: "21",
                                  onClick: ($event: any) => (header.click ? header.click(value) : () => {})
                                }, null, 8, ["name", "onClick"])
                              ]))
                        ], 4))
                      }), 256))
                    ]))
                  }), 256))
                ]),
                (values.value.length > 5)
                  ? (_openBlock(), _createBlock(_component_base_pagination_group, {
                      key: 0,
                      modelValue: prepareValues.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((prepareValues).value = $event)),
                      "show-btn": false,
                      "step-for-visible": 10,
                      values: values.value,
                      class: "mt--30"
                    }, null, 8, ["modelValue", "values"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_base_card, {
              key: 1,
              class: "wallet items-in-column align-center"
            }, {
              default: _withCtx(() => [
                _hoisted_10,
                _createVNode(_component_base_button, {
                  href: { name: 'main' },
                  height: "40",
                  text: "К объявлениям"
                })
              ]),
              _: 1
            })),
        (!!successDeleteMessage.value)
          ? (_openBlock(), _createBlock(_component_base_info_modal, {
              key: 2,
              "show-info-modal": !!successDeleteMessage.value,
              onClose: _cache[1] || (_cache[1] = ($event: any) => (successDeleteMessage.value = undefined))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(successDeleteMessage.value), 1)
              ]),
              _: 1
            }, 8, ["show-info-modal"]))
          : _createCommentVNode("", true)
      ]))
}
}

})